module.exports = __webpack_public_path__ + "static/media/Nature Sound Series Аюрведа - Японская музыка.92ba1114.mp3";